import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import { FullPageMessage } from '@/components/FullPageMessage';
import { SignIn } from '@/pages/SignIn';

/** Keep deep links across the existing PKCE handoff from the welcome screen. */
export function RequireAuth({ children }: { children: ReactNode }): ReactNode {
  const { status, error, signIn } = useAuth();
  const location = useLocation();
  const returnTo = `${location.pathname}${location.search}`;
  if (status === 'authenticated') return children;
  if (status === 'initialising') return <FullPageMessage title="Opening your workspace" detail="Checking your secure session." busy />;
  return <SignIn onSignIn={() => signIn(returnTo)} error={error} />;
}
